export const automotiveLandingKeys = {
  all: () => ['AUTOMOTIVE_LANDING'],
};
